import { Directive, OnInit, inject, signal } from '@angular/core';

import { ListService, TrackByService } from '@abp/ng.core';

import type { AddressDto, GetAddressesInput } from '../../../proxy/addresses/models';
import { AddressViewService } from '../services/address.service';
import { AddressDetailViewService } from '../services/address-detail.service';

export const ChildTabDependencies = [];

export const ChildComponentDependencies = [];

@Directive({ standalone: true })
export abstract class AbstractAddressComponent implements OnInit {
  public readonly list = inject(ListService);
  public readonly track = inject(TrackByService);
  public readonly service = inject(AddressViewService);
  public readonly serviceDetail = inject(AddressDetailViewService);
  protected title = '::AddressDetails';
  // Signals, not plain fields: set in a subscribe and read by the OnPush-hosted template (#36).
  public readonly isLoading = signal(true);
  public readonly addresses = signal<Array<AddressDto>>([]);

  ngOnInit() {
    this.service.hookToQuery();
  }

  clearFilters() {
    this.service.clearFilters();
  }

  showForm() {
    this.serviceDetail.showForm();
  }

  create() {
    this.serviceDetail.selected.set(undefined);
    this.serviceDetail.showForm();
  }

  update(record: AddressDto) {
    this.serviceDetail.update(record);
  }

  delete(record: AddressDto, _this) {
    this.service.delete(record).subscribe({
      next: () => this.fetchAddresses(_this),
    });
  }

  exportToExcel() {
    this.service.exportToExcel();
  }

  setDefault(record: AddressDto, _this) {
    this.service.setDefault(record).subscribe({
      next: () => this.fetchAddresses(_this),
    });
  }

  fetchAddresses(_this) {
    // Explicit paging and sorting: a user may keep any number of addresses, and without
    // maxResultCount the list silently stops at the server's default page size. Default first.
    this.service
      .getList({ maxResultCount: 100, sorting: 'IsDefault desc' } as GetAddressesInput)
      .subscribe({
      next: results => {
        _this.isLoading.set(false);
        _this.addresses.set(results.items);
      },
      error: results => {
        _this.isLoading.set(false);
      },
    });
  }
}
